import * as React from 'react';
import { CONSTANTS } from '../../../assets/UIConstants';

interface Props {
    height?: number;
    color?: string;
    width?: number;
}

class DropDownIcon extends React.Component<Props, {}> {

    public static defaultProps: Partial<Props> = {
        width: 16,
        height: 16,
        color: CONSTANTS.COLORS.DARKEST_GREY
    };

    public render(): JSX.Element {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="2998.086 3659.086 19.828 28.828" height={this.props.height} width={this.props.width}>
                <g id="Group_43" data-name="Group 43" transform="translate(2200 3541)">
                    <path id="Path_41" data-name="Path 41" fill={this.props.color} d="M14.521.5V14.521H.5Z" transform="translate(808 138.621) rotate(-135)"/>
                    <path id="Path_42" data-name="Path 42" fill={this.props.color} d="M14.521.5V14.521H.5Z" transform="translate(808 126.379) rotate(45)"/>
                </g>
            </svg>
        );
    }
};



export default DropDownIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/DropDownIcon.tsx